import { Table } from "react-bootstrap"
import { useNavigate } from "react-router-dom"

import { useFetchUserDataQuery } from "../../../app/userApiSlice"
import Spinner from "../../../components/Spinner"
import DisplayErrorMessage from "../../../components/DisplayErrorMessage"
import useAuth from "../../../hooks/useAuth"
import formatClubName from "../../../utils/formatClubName"
import PositionBadges from "../../../components/PositionBadges"
import LeaveClubButton from "../../../components/buttons/table/LeaveClubButton"
import ViewClubButton from "../../../components/buttons/table/ViewClubButton"


const UserClubsPage = () => {
  const navigate = useNavigate()
  const { uid } = useAuth()
  const { data, isSuccess, isLoading, isError, error } = useFetchUserDataQuery(uid)

  const handleViewClub = (clubId) => navigate(`/user/clubs/view-club/${clubId}`)

  if (isLoading) return <Spinner />
  if (isError) {
    console.error(error || "Error: An unknown error occurred while fetching clubs")
    return <DisplayErrorMessage>Error fetching clubs</DisplayErrorMessage>
  }
  if (!isSuccess || !data) return null

  let tableContent

  if (data?.clubs?.length < 1) {
    tableContent = (
      <tr>
        <td colSpan={12} className="text-center">
          No clubs found
        </td>
      </tr>
    )
  } else {
    tableContent = data.clubs.map((club) => {
      return (
        <tr key={club.clubId}>
          <td className="col-3">{formatClubName(club.clubName)}</td>
          <td className="col-3">{club.clubId}</td>
          <td className="col-2 align-middle">
            <div className="d-flex flex-column gap-1 align-items-center">
              <PositionBadges positions={club.positions} />
            </div>
          </td>
          <td className="">
            <div className="d-flex gap-2 p-0 m-0 justify-content-center">
              <ViewClubButton action={() => handleViewClub(club.clubId)} />
              <LeaveClubButton clubId={club.clubId} uid={uid} clubName={club.clubName} />
            </div>
          </td>
        </tr>
      )
    })
  }

  return (
    <>
      <h3 className="mb-4 text-start w-100 fw-bold">Your Clubs</h3>

      <div className="overflow-auto w-100 rounded-4 py-4 px-4 shadow-sm bg-white" style={{ maxHeight: "400px" }}>
        <Table hover responsive className="mb-0 mt-1" style={{ minWidth: "650px" }}>
          <thead>
            <tr>
              <th className="">Club Name</th>
              <th className="">Club Number</th>
              <th className=" text-center">Positions</th>
              <th className="col-auto text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {tableContent}
          </tbody>
        </Table>
      </div>
    </>
  )
}

export default UserClubsPage